const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '작성일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['작성일', '작성년도']}
      },
      {
        'component': 'search-year', label: '연도', value: 'year', query: {'y': 'year'},
        options: {
          default: new Date().getFullYear()
        }
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let dateTarget = "body.stdInfo.date";
    let dateBegin = `${new Date().getFullYear()}-01-01`;
    let dateEnd = `${new Date().getFullYear()}-12-31`;
    if (search.year) {
      dateBegin = `${search.year}-01-01`;
      dateEnd = `${search.year}-12-31`;
    }
    //  검색일
    if (search.date) {
      if (search.date.startDate) dateBegin = search.date.startDate;
      if (search.date.endDate) dateEnd = search.date.endDate;
    }
    conditions.push({key: dateTarget, operator: '>=', value: dateBegin})
    conditions.push({key: dateTarget, operator: '<', value: new Date(dateEnd).addDays(1).format("yyyy-MM-dd")})


    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      { name: '작성년도', key: 'body.stdInfo.date'},
      { name: '부서', key: 'body.stdInfo.field_name'},
      { name: '구분', key: 'body.구분'},
      { name: '소속명', key: 'body.stdInfo.department'},
      { name: '부서명', key: 'body.stdInfo.section'},
      { name: '작성자', key: 'body.stdInfo.writer_name'},
      { name: '작성일', key: 'body.stdInfo.date'},
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.date? func.getContent(value).stdInfo.date.split('-')[0] : '' // 작성년도

        // 부서
        case 1: return func.getContent(value).stdInfo.field_name
        // 구분
        case 2: return func.getContent(value).구분
        // 소속명
        case 3: return func.getContent(value).stdInfo.department
        // 부서명
        case 4: return func.getContent(value).stdInfo.section
        // 작성자
        case 5: return func.getContent(value).stdInfo.writer_name
        // 작성일
        case 6: return func.getCreatedDate(func.getContent(value).stdInfo.date)
      }
    } catch (e) { /*ignore*/
    }
    return ''
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},

  excelInfo: (list) => {
    return {
      filePath: '/fms/위험성평가_엑셀다운로드_rev.0.1.xlsx',
      downloadFileName: '위험성평가',
      worksheetName: (data) => {
        return '위험성평가'
      },
      applyDataToSheet: async (worksheet, data, func) => {

        const getResultRisk = (point) => {
          if (point >=1 && point <= 2) return {
            name: '낮음',
            color: '#28C76F',
          };
          else if (point >= 3 && point <= 4) return {
            name: '보통',
            color: '#FF8510',
          };
          else return {
              name: '높음',
              color: '#E42728',
            };
        }

        const body = data.body
        const merges = func.getMerges();

        // 기본정보
        func.setMerges(["D1:M6", "A7:A8", "B7:B8", "C7:C8", "D7:D8", "E7:E8", "F7:G7", "H7:H8", "I7:L7", "K8:L8", "M7:M8"])
        worksheet.getCell('B1').value = body.stdInfo.field_name //부서
        worksheet.getCell('B2').value = body.stdInfo.section //작성부서
        worksheet.getCell('B3').value = body.stdInfo.writer_name //작성자
        worksheet.getCell('B4').value = body.stdInfo.date //작성일
        worksheet.getCell('B5').value = body.차수 //차수
        worksheet.getCell('B6').value = body.적용기간_시작일 //적용기간 시작일
        worksheet.getCell('C6').value = body.적용기간_종료일 //적용기간 종료일
        worksheet.getCell('D1').value = `${body.구분.split('').join(' ')} 위 험 성 평 가`

        // 위험성평가표
        let nextRowIndex = 9; // excel 행 번호
        const 위험성평가표 = body.위험성평가표
        for (let i=0; i<위험성평가표.length; i++ ) {
          const row = 위험성평가표[i]
          worksheet.insertRow(nextRowIndex, [
            i + 1,
            row.현업업무,
            row.작업분류,
            row.작업시위험사항,
            `${row.예상재해형태_분야}_${row.예상재해형태_내용}`,
            row.개선전_위험도,
            row.개선전_안전보건조치,
            row.개선대책,
            row.현재위험도_가능성,
            row.현재위험도_중대성,
            row.현재위험도_위험도,
            getResultRisk(row.현재위험도_위험도).name,
            row.개선완료여부,
          ])


          worksheet.getRow(nextRowIndex).height = 30
          nextRowIndex++;
        }
      }
    }
  }
}

export default list;
